export const PaxConstants = Object.freeze({
    ADULTS: 'adults',
    KIDS: 'kids',
    INFANTS: 'infants',
    ROOMS: 'rooms',
});
